import {BriefcaseBusiness} from 'lucide-react';
import {useTranslation} from 'react-i18next';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {IconButton} from '@/components/ui/icon-button';
import WorkScheduleMenuSection from '@/shared/work-schedule/components/WorkScheduleMenuSection';
import {useCanViewWorkSchedule} from '@/shared/work-schedule/hooks/useCanViewWorkSchedule';
import WorkTimeMenuSection from '@/shared/work-time/components/WorkTimeMenuSection';
import WorkTimeStatusDot from '@/shared/work-time/components/WorkTimeStatusDot';
import {useCanTrackWorkTime} from '@/shared/work-time/hooks/useCanTrackWorkTime';

const MyWorkDropdown = () => {
  const {t} = useTranslation();
  const canTrackWorkTime = useCanTrackWorkTime();
  const canViewWorkSchedule = useCanViewWorkSchedule();

  if (!canTrackWorkTime && !canViewWorkSchedule) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <IconButton
          type="button"
          variant="tertiary"
          size="default"
          className="relative shrink-0 bg-white shadow-subtle"
          aria-label={t('My work')}
        >
          <BriefcaseBusiness />
          <WorkTimeStatusDot />
        </IconButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="bottom" align="end" className="min-w-56">
        {canTrackWorkTime && <WorkTimeMenuSection />}
        {canTrackWorkTime && canViewWorkSchedule && <DropdownMenuSeparator />}
        {canViewWorkSchedule && <WorkScheduleMenuSection />}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default MyWorkDropdown;
